import { atom } from "recoil";

// Per-game combined odd returned by get_bet_builder_odds (OddsPerMatch[i].Odd).
export interface IBetBuilderGroupState {
  combinedPrice: number;
  selectionIds: number[];
  loading: boolean;
}

export interface IBetBuilderStoreValue {
  // Odd per game (MatchId => combined price for that game).
  groups: Record<number, IBetBuilderGroupState>;
  // Aggregate odd across all bet builder groups (TotalOdd from swarm).
  totalOdd: number;
  // Server-rejected selection ids from the last odds request, if any.
  rejectedIds: number[];
}

const betBuilderStore = atom<IBetBuilderStoreValue>({
  key: "betBuilderStore",
  default: {
    groups: {},
    totalOdd: 0,
    rejectedIds: [],
  },
});

export default betBuilderStore;
